import { useEffect, useState }from 'react';

const UseProducts = () => {
    const [data, setData] = useState([]);
    const [leakedData, setLeakedData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const dataPerPage = 20;
    const [totalPages, setTotalPages] = useState(0);
    const [wasCreated, setWasCreated] = useState('');
    const [filters, setFilters] = useState({
        name: '',
        code: '',
        date: '', 
        brand: '',
        model: '',
    });
    const [lengths, setLengths] = useState({
        dataLength: 0,
        leakedLength: 0
    });
    const [isLoading, setIsLoading] = useState(true);
    
    const do_filters = () => {
        if(filters.name==='' && filters.code==='' && filters.date==='' && filters.brand==='' && filters.model==='') {
            setLeakedData(data);
            setTotalPages(Math.ceil(data.length / dataPerPage));
            localStorage.setItem('set_filters', "no");

        }
        else {
            var arr = [];
            data.forEach(element=>{
                if(compareStrings(element) === true) {
                    arr.push(element);
                }
            });
            setLeakedData(arr);
            setLengths({
                ...lengths,
                leakedLength: arr.length
            });
            setTotalPages(Math.ceil(arr.length / dataPerPage));
        }
        setCurrentPage(1);
    }
    
    useEffect(() => {
        const config = {
            method: 'GET',
            headers: {
                Authorization: `Token ${localStorage.getItem('token')}`,    
            }
        }
        if(isLoading){
            fetch("https://api.gestor.mkr.cl/get_products/", config)
                .then(response => {
                    response.json()
                    .then(data => {
                        setData(data);
                        setIsLoading(false);
                        setLengths({
                            dataLength: data.length,
                            leakedLength: data.length
                        });
                    })
                })
            .catch(err => {
                setIsLoading(true);
                console.log(err)
            })
            .finally(() => {
                if(localStorage.getItem('set_filters') === 'yes') {
                    setFilters({
                        name: localStorage.getItem('filter_name'),
                        code: localStorage.getItem('filter_code'),
                        date: localStorage.getItem('filter_date'), 
                        brand: localStorage.getItem('filter_brand'),
                        model: localStorage.getItem('filter_model'),
                    });
                    do_filters();
                } else {
                    setTotalPages(Math.ceil(data.length / dataPerPage));
                    setLeakedData(data);
                } 
            })
        }        
    }, [isLoading, data, do_filters]);
   
    const paginate = (number) => {
        setCurrentPage(number);
    }

    const handleInput = (e) => {
        const {name, value} = e.target;
        setFilters({
            ...filters,
            [name]: value
        });
    } 
    
    
    const compareStrings = (element) => {
        var bool = true;
        var str1 = '';
        var str2 = '';
        if(filters.name != '' && bool===true){
            str1 = element.name.toUpperCase();
            str2 = filters.name.toUpperCase();
            if(str1.includes(str2) === false) {
                bool = false;
            }
        }
        if(filters.code != '' && bool===true){
            str1 = element.ficha_code.toUpperCase();
            str2 = filters.code.toUpperCase();
            if(str1.includes(str2) === false) {
                bool = false;
            }
        }
        if(filters.date != '' && bool===true){
            str1 = element.last_update.toUpperCase();
            str2 = filters.date.toUpperCase();
            if(str1.includes(str2) === false) {
                bool = false;
            }
        }
        if(filters.brand != '' && bool===true){
            str1 = element.brand.toUpperCase();
            str2 = filters.brand.toUpperCase();
            if(str1.includes(str2) === false) {
                bool = false;
            }
        }
        if(filters.model != '' && bool===true){
            str1 = element.model.toUpperCase();
            str2 = filters.model.toUpperCase();
            if(str1.includes(str2) === false) {
                bool = false;
            }
        }
        return bool;
    }

    const handleSubmit = (e) => {
        if(e.key==="Enter") {
            localStorage.setItem('set_filters', "yes");
            localStorage.setItem('filter_name', filters.name);
            localStorage.setItem('filter_brand', filters.brand);
            localStorage.setItem('filter_model', filters.model);
            localStorage.setItem('filter_date', filters.date);
            localStorage.setItem('filter_code', filters.code);
            do_filters();
        } 
    } 
    const filtersOff = () => {
        setFilters({
            name: '',
            code: '',
            date: '', 
            brand: '',
            model: '',
        });
        localStorage.setItem('set_filters', "no");
            localStorage.setItem('filter_name', '');
            localStorage.setItem('filter_brand', '');
            localStorage.setItem('filter_model', '');
            localStorage.setItem('filter_date', '');
            localStorage.setItem('filter_code', '');
        setLeakedData(data);
        setLengths({
            ...lengths,
            leakedLength: data.length
        });
        setTotalPages(Math.ceil(data.length / dataPerPage));    
    }

    const handleCreateDetail = (e) => {
        e.preventDefault();
        const config = {
            method: 'POST',
            headers: {
                Authorization: `Token ${localStorage.getItem('token')}`,    
            },
            body: JSON.stringify({user:localStorage.getItem('username')})

        }
        fetch(`https://api.gestor.mkr.cl/addsimpleproduct/`, config)
        .then(response => {
            response.json()
            .then(data => {
                if(data.status === 'created') {
                    setWasCreated(data.code);
                } 
            })
        })
        .catch(err => {
            console.log(err)
        })


    }
    
    return {leakedData, filters, lengths, dataPerPage, currentPage, totalPages, wasCreated, paginate, filtersOff, handleInput, handleSubmit, handleCreateDetail};
}

export default UseProducts;
